import { render, staticRenderFns } from "./CompetitionModal.vue?vue&type=template&id=cdf7aab6&scoped=true&"
import script from "./CompetitionModal.vue?vue&type=script&lang=js&"
export * from "./CompetitionModal.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionModal.vue?vue&type=style&index=0&id=cdf7aab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf7aab6",
  null
  
)

export default component.exports